export default __webpack_public_path__ + "static/media/logo-tnt.4cd54152.png";